import React, { useState } from 'react';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import ScrollableContainer from 'components/shared/scrollable';
import StickySidebar from 'components/shared/StickySidebar';
import { routes } from 'constants/config';
import { Button } from 'ui';
import FormattedDate from 'components/shared/FormattedDate';
import ArchiveConfirmation from './ArchiveConfirmation';
import RestoreConfirmation from './RestoreConfirmation';
import ScenarioDescription from './ScenarioDescription';
import GroupListingVisibility from './GroupListingVisibility';

const Sidebar = ({
  scenario,
  updateScenario,
  userCanEditScenario,
  userCanManageUsers,
}) => {
  const [showArchiveConfirmation, setShowArchiveConfirmation] = useState(false);
  const [showRestoreConfirmation, setShowRestoreConfirmation] = useState(false);

  return (
    <>
      <StickySidebar className="PathBuilderSidebar">
        <ScrollableContainer maxHeight={null} hidden>
          <Section className="d-f">
            {scenario.archived && userCanEditScenario && (
              <Button
                className="NewButton--white NewButton--center undecorated c-brand-gray-darker f-1 mr-8"
                icon="restore"
                fullWidth
                onClick={() => setShowRestoreConfirmation(true)}
                small
              >
                {t('actions.restore')}
              </Button>
            )}
            {!scenario.archived && userCanEditScenario && (
              <Button
                className="NewButton--white NewButton--center undecorated c-brand-gray-darker f-1 mr-8 mb-0"
                icon="archive"
                fullWidth
                onClick={() => setShowArchiveConfirmation(true)}
                small
              >
                {t('actions.archive')}
              </Button>
            )}
            <Button
              className="NewButton--white NewButton--center undecorated c-brand-gray-darker f-1 "
              icon="preview"
              fullWidth
              url={routes.ON_DEMAND_PRACTICE.PREVIEW.SHOW(scenario.id)}
              target="_blank"
              small
            >
              {t('actions.preview')}
            </Button>
          </Section>
          <Section className="d-f fd-c">
            <ScenarioDescription
              scenario={scenario}
              updateScenario={updateScenario}
              userCanEditScenario={userCanEditScenario}
            />
          </Section>
          <Section>
            <SectionHeader>{t('common.created_at')}</SectionHeader>
            <FormattedDate>{scenario.createdAt}</FormattedDate>
            <br />
            {t('common.by')} {scenario.createdBy}
            {scenario.lastUpdatedAt && (
              <>
                <SectionHeader className="mt-16">
                  {t('common.last_updated')}
                </SectionHeader>
                <FormattedDate>{scenario.lastUpdatedAt}</FormattedDate>
                <br />
                {t('common.by')} {scenario.lastUpdatedBy}
              </>
            )}
          </Section>
          {userCanEditScenario && userCanManageUsers && (
            <GroupListingVisibility scenario={scenario} />
          )}
        </ScrollableContainer>
      </StickySidebar>
      {showArchiveConfirmation && (
        <ArchiveConfirmation
          scenario={scenario}
          onDismiss={() => setShowArchiveConfirmation(false)}
        />
      )}
      {showRestoreConfirmation && (
        <RestoreConfirmation
          scenario={scenario}
          onDismiss={() => setShowRestoreConfirmation(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
